<template>
  <Modal v-model="modalUploadAttachment" footer-hide width="1000">
    <p slot="header" class="text-center">
        <span>上传附件</span>
    </p>
    <Row>
      <i-col span="24">
        <Upload
          ref="uploadRef"
          multiple
          type="drag"
          :headers="headers"
          :action="uploadUrl"
          :on-success="handleUploadSuccess"
          :on-remove="handleRemoveFile"
        >
            <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击或拖拽文件到这里进行上传</p>
            </div>
        </Upload>
      </i-col>
    </Row>
    <p class="p-t-10">
      <i-button size="small"  type="success" :disabled="uploadList.length<1" @click="handleSaveAttach">确认上传</i-button>
    </p>
    <div class="text-16 m-t-10">
      历史上传文件
      <Divider style="margin: 5px 0;"/>
      <List v-if="historyUploadAttach.length>0">
        <ListItem v-for="(item,index) in historyUploadAttach" :key="index">
            <ListItemMeta :title="item.createTime+'（' + item.userName + '）' ">
              <div slot="description">
                <a v-for="file in item.contentList" :key="file.attachId" class="m-r-20"
                  @click="handleDownloadFile(file)">{{ file.name }}</a>
              </div>
            </ListItemMeta>
        </ListItem>
      </List>
      <p v-else class="text-center remark p-t-10">暂无数据</p>
    </div>
  </Modal>
</template>

<script>
import { getStorage } from '@/utils/storage'
import { signurlByAttach } from '@/api/resource/endpoint'
import { downloadFileRequest } from '@/utils/download'
import { getServiceAttachList, addAttach } from '@/api/msp/serviceversion'

export default {
  data () {
    return {
      modalUploadAttachment: false,
      serviceVersionId: 0,

      uploadUrl: `${process.env.VUE_APP_API_URL_V2}/ooh-resource/oss/endpoint/put-file-attach`,
      headers: {
        'ooh-auth': getStorage('ooh-token')
      }, // 上传组件设置协议头
      uploadList: [],

      historyUploadAttach: []
    }
  },
  methods: {
    showModal (serviceVersionId) {
      this.modalUploadAttachment = true
      this.$refs.uploadRef.clearFiles()
      this.serviceVersionId = serviceVersionId

      this.loadAttachList()
    },
    loadAttachList () {
      getServiceAttachList({ serviceVersionId: this.serviceVersionId }).then(res => {
        this.historyUploadAttach = res
      })
    },
    handleUploadSuccess (response, file, fileList) {
      const files = []
      fileList.forEach(x => {
        files.push({
          name: x.name,
          attachId: x.response.data.id
        })
      })

      this.uploadList = files
    },
    handleRemoveFile (file, fileList) {
      const files = []
      fileList.forEach(x => {
        files.push({
          name: x.name,
          attachId: x.response.data.id
        })
      })

      this.uploadList = files
    },
    handleDownloadFile (file) {
      signurlByAttach({ attachId: file.attachId }).then(res => {
        downloadFileRequest(res.data, { }, file.name)
      })
    },
    handleSaveAttach () {
      const saveBean = {
        attaches: JSON.stringify(this.uploadList),
        versionId: this.serviceVersionId
      }

      addAttach(saveBean).then(res => {
        this.loadAttachList()
        this.uploadList = []
        this.$refs.uploadRef.clearFiles()
        this.$Notice.success({ desc: '版本附件上传成功！' })
      })
    }
  }
}
</script>
